// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import { takeLatest, put, all, call } from 'redux-saga/effects';

import KYCVerificationActionTypes from './kyc-verification.types';
import {
	kYCaadharAdd,
	kYCaadharAddotp,
	kYCpanAdd,
	kYCgstAdd,
	kYCcinAdd,
	kYCitrAdd,
	kYCmcaAdd,
} from './kyc-verification.service';

import {
	callKYCAadharSuccess,
	callKYCAadharFailure,
	callKYCAadharResponseChanged,
	callKYCAadharotpSuccess,
	callKYCAadharotpFailure,
	callKYCAadharotpResponseChanged,
	callKYCPanSuccess,
	callKYCPanFailure,
	callKYCPanResponseChanged,
	callKYCgstSuccess,
	callKYCgstFailure,
	callKYCgstResponseChanged,
	callKYCcinSuccess,
	callKYCcinFailure,
	callKYCcinResponseChanged,
	callKYCitrSuccess,
	callKYCitrFailure,
	callKYCitrResponseChanged,
	callKYCmcaSuccess,
	callKYCmcaFailure,
	callKYCmcaResponseChanged,
} from './kyc-verification.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START ADD KYC VERIFICATION  ******************** */
export function* KYCaadharAdd({ payload }: any) {
	try {
		const { businessID, companyID, generalCompanyID, userID, databaseName, aadharNumber } =
			payload;
		const key = 'AadharVerifyKYCKEY';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			GeneralCompanyID: generalCompanyID,
			UserID: userID,
			DatabaseName: databaseName,
			AadharNumber: aadharNumber,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(kYCaadharAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(callKYCAadharFailure(responseData.data));
		} else {
			yield put(callKYCAadharSuccess(responseData.data));
		}
	} catch (error) {
		yield put(callKYCAadharFailure(error));
	}
}

export function* resetAddKYCaadharResponse() {
	yield put(callKYCAadharResponseChanged());
}

export function* onAddaadharKYCVerification() {
	yield takeLatest(KYCVerificationActionTypes.CALL_KYC_ADDHAR_START, KYCaadharAdd);
}

export function* onAddaadharKYCVerificationResponseReset() {
	yield takeLatest(
		KYCVerificationActionTypes.CALL_KYC_ADDHAR_RESPONSE_RESET,
		resetAddKYCaadharResponse,
	);
}
/** *********************  END ADD KYC VERIFICATION ******************** */

/** *********************  START ADD KYC VERIFICATION  ******************** */
export function* KYCaadharAddotp({ payload }: any) {
	try {
		const {
			businessID,
			companyID,
			generalCompanyID,
			userID,
			databaseName,
			partiesAadharotpNumber,
		} = payload;
		const key = 'AadharVerifyKYCKEY';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			GeneralCompanyID: generalCompanyID,
			UserID: userID,
			DatabaseName: databaseName,
			AadharotpNumber: partiesAadharotpNumber,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(kYCaadharAddotp, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(callKYCAadharotpFailure(responseData.data));
		} else {
			yield put(callKYCAadharotpSuccess(responseData.data));
		}
	} catch (error) {
		yield put(callKYCAadharotpFailure(error));
	}
}

export function* resetAddKYCaadharotpResponse() {
	yield put(callKYCAadharotpResponseChanged());
}

export function* onAddaadharotpKYCVerification() {
	yield takeLatest(KYCVerificationActionTypes.CALL_KYC_ADDHAR_OTP_START, KYCaadharAddotp);
}

export function* onAddaadharotpKYCVerificationResponseReset() {
	yield takeLatest(
		KYCVerificationActionTypes.CALL_KYC_ADDHAR_OTP_RESPONSE_RESET,
		resetAddKYCaadharotpResponse,
	);
}
/** *********************  END ADD KYC VERIFICATION ******************** */

/** *********************  START ADD KYC VERIFICATION  ******************** */
export function* KYCpanAdd({ payload }: any) {
	try {
		const { businessID, companyID, generalCompanyID, userID, databaseName, panNumber } =
			payload;
		const key = 'AppVerifyKYCKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			GeneralCompanyID: generalCompanyID,
			UserID: userID,
			DatabaseName: databaseName,
			PanNumber: panNumber,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(kYCpanAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(callKYCPanFailure(responseData.data));
		} else {
			yield put(callKYCPanSuccess(responseData.data));
		}
	} catch (error) {
		yield put(callKYCPanFailure(error));
	}
}

export function* resetAddKYCpanResponse() {
	yield put(callKYCPanResponseChanged());
}

export function* onAddpanKYCVerification() {
	yield takeLatest(KYCVerificationActionTypes.CALL_KYC_PAN_START, KYCpanAdd);
}

export function* onAddpanKYCVerificationResponseReset() {
	yield takeLatest(
		KYCVerificationActionTypes.CALL_KYC_PAN_RESPONSE_RESET,
		resetAddKYCpanResponse,
	);
}
/** *********************  END ADD KYC VERIFICATION ******************** */

/** *********************  START ADD KYC VERIFICATION  ******************** */
export function* KYCgstAdd({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, branchListArr } = payload;
		const key = 'BusinessBranchKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			BusinessBranchList: branchListArr,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(kYCgstAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(callKYCgstFailure(responseData.data));
		} else {
			yield put(callKYCgstSuccess(responseData.data));
		}
	} catch (error) {
		yield put(callKYCgstFailure(error));
	}
}

export function* resetAddKYCgstResponse() {
	yield put(callKYCgstResponseChanged());
}

export function* onAddgstKYCVerification() {
	yield takeLatest(KYCVerificationActionTypes.CALL_KYC_GST_START, KYCgstAdd);
}

export function* onAddgstKYCVerificationResponseReset() {
	yield takeLatest(
		KYCVerificationActionTypes.CALL_KYC_GST_RESPONSE_RESET,
		resetAddKYCgstResponse,
	);
}
/** *********************  END ADD KYC VERIFICATION ******************** */

/** *********************  START ADD KYC VERIFICATION  ******************** */
export function* KYCcinAdd({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, branchListArr } = payload;
		const key = 'BusinessBranchKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			BusinessBranchList: branchListArr,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(kYCcinAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(callKYCcinFailure(responseData.data));
		} else {
			yield put(callKYCcinSuccess(responseData.data));
		}
	} catch (error) {
		yield put(callKYCcinFailure(error));
	}
}

export function* resetAddKYCcinResponse() {
	yield put(callKYCcinResponseChanged());
}

export function* onAddcinKYCVerification() {
	yield takeLatest(KYCVerificationActionTypes.CALL_KYC_CIN_START, KYCcinAdd);
}

export function* onAddcinKYCVerificationResponseReset() {
	yield takeLatest(
		KYCVerificationActionTypes.CALL_KYC_CIN_RESPONSE_RESET,
		resetAddKYCcinResponse,
	);
}
/** *********************  END ADD KYC VERIFICATION ******************** */

/** *********************  START ADD KYC VERIFICATION  ******************** */
export function* KYCitrAdd({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, branchListArr } = payload;
		const key = 'BusinessBranchKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			BusinessBranchList: branchListArr,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(kYCitrAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(callKYCitrFailure(responseData.data));
		} else {
			yield put(callKYCitrSuccess(responseData.data));
		}
	} catch (error) {
		yield put(callKYCitrFailure(error));
	}
}

export function* resetAddKYCitrResponse() {
	yield put(callKYCitrResponseChanged());
}

export function* onAdditrKYCVerification() {
	yield takeLatest(KYCVerificationActionTypes.CALL_KYC_ITR_START, KYCitrAdd);
}

export function* onAdditrKYCVerificationResponseReset() {
	yield takeLatest(
		KYCVerificationActionTypes.CALL_KYC_ITR_RESPONSE_RESET,
		resetAddKYCitrResponse,
	);
}
/** *********************  END ADD KYC VERIFICATION ******************** */

/** *********************  START ADD KYC VERIFICATION  ******************** */
export function* KYCmcaAdd({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, branchListArr } = payload;
		const key = 'BusinessBranchKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			BusinessBranchList: branchListArr,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(kYCmcaAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(callKYCmcaFailure(responseData.data));
		} else {
			yield put(callKYCmcaSuccess(responseData.data));
		}
	} catch (error) {
		yield put(callKYCmcaFailure(error));
	}
}

export function* resetAddKYCmcaResponse() {
	yield put(callKYCmcaResponseChanged());
}

export function* onAddmcaKYCVerification() {
	yield takeLatest(KYCVerificationActionTypes.CALL_KYC_MCA_START, KYCmcaAdd);
}

export function* onAddmcaKYCVerificationResponseReset() {
	yield takeLatest(
		KYCVerificationActionTypes.CALL_KYC_MCA_RESPONSE_RESET,
		resetAddKYCmcaResponse,
	);
}
/** *********************  END ADD KYC VERIFICATION ******************** */
export function* kYCVerificationSaga() {
	yield all([
		call(onAddaadharKYCVerification),
		call(onAddaadharKYCVerificationResponseReset),
		call(onAddaadharotpKYCVerification),
		call(onAddaadharotpKYCVerificationResponseReset),
		call(onAddpanKYCVerification),
		call(onAddpanKYCVerificationResponseReset),
		call(onAddgstKYCVerification),
		call(onAddgstKYCVerificationResponseReset),
		call(onAddcinKYCVerification),
		call(onAddcinKYCVerificationResponseReset),
		call(onAdditrKYCVerification),
		call(onAdditrKYCVerificationResponseReset),
		call(onAddmcaKYCVerification),
		call(onAddmcaKYCVerificationResponseReset),
	]);
}
